var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIlustracaoAtencao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 159.58 103.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Gradiente_sem_nome_3-3);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-width: 0px;\n      }\n\n      .cls-13 {\n        stroke: #071d41;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-13, .cls-5 {\n        fill: none;\n      }\n\n      .cls-14 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: url(#Gradiente_sem_nome_3-2);\n      }\n\n      .cls-3 {\n        fill: #e5a000;\n      }\n\n      .cls-4 {\n        fill: #fdf5e6;\n      }\n\n      .cls-6 {\n        fill: url(#Gradiente_sem_nome_6);\n      }\n\n      .cls-7 {\n        fill: #f08080;\n      }\n\n      .cls-8 {\n        fill: url(#Gradiente_sem_nome_4);\n      }\n\n      .cls-9 {\n        fill: #fff;\n      }\n\n      .cls-10 {\n        fill: url(#Gradiente_sem_nome_3);\n      }\n\n      .cls-11 {\n        fill: url(#Gradiente_sem_nome_6-2);\n      }\n\n      .cls-12 {\n        fill: #1351b4;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3",
    "data-name": "Gradiente sem nome 3",
    x1: 6843.39,
    y1: -333.32,
    x2: 6832.75,
    y2: -351.15,
    gradientTransform: "translate(6857.85 -293.52) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5992ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155bcb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3-2",
    "data-name": "Gradiente sem nome 3",
    x1: 6818.11,
    y1: -295.25,
    x2: 6773.62,
    y2: -392.6,
    xlinkHref: "#Gradiente_sem_nome_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3-3",
    "data-name": "Gradiente sem nome 3",
    x1: 5820.76,
    y1: 69.05,
    x2: 5775.49,
    y2: -30.01,
    gradientTransform: "translate(2897.22 -5007.03) rotate(118.72)",
    xlinkHref: "#Gradiente_sem_nome_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_4",
    "data-name": "Gradiente sem nome 4",
    x1: 6705.08,
    y1: -346,
    x2: 6850.99,
    y2: -346,
    gradientTransform: "translate(6857.85 -293.52) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40e0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5d4eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6",
    "data-name": "Gradiente sem nome 6",
    x1: 68.43,
    y1: -387.31,
    x2: 92.09,
    y2: -387.31,
    gradientTransform: "translate(0 -293.52) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f174d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e2bb1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6-2",
    "data-name": "Gradiente sem nome 6",
    x1: 38.56,
    y1: -376.27,
    x2: 121.97,
    y2: -376.27,
    xlinkHref: "#Gradiente_sem_nome_6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2-2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fundo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cor",
    className: "cls-10",
    d: "M16.22,38.52c-6.79,3.63-9.63,13.1-4.45,22.36,1.3,2.32,3.29,3.86,5.25,3.44,4.57-.98,6.23-10.53,10.6-12.35,1.06-.44,2.2-.38,3.2-1.06,5.5-3.77-2.29-18.98-14.6-12.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-2",
    className: "cls-2",
    d: "M31.25,66.17c12.87,27.19,37.34,40.5,54.57,32.34,17.23-8.16,20.69-34.7,7.82-61.89C80.77,9.45,56.37-5.97,39.14,2.18c-17.23,8.16-20.76,36.81-7.89,63.99h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-3",
    className: "cls-1",
    d: "M88.13,103.14c30.03,1.78,59.07-13.01,60.19-32.04,1.12-19.03-22.3-35.89-52.33-37.67-30.03-1.78-55.28,12.21-56.4,31.24-1.12,19.03,18.51,36.7,48.53,38.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-4",
    className: "cls-8",
    d: "M135.28,8.58C124.23,2.53,111.04.5,98.69,2.93c-12.36,2.43-23.79,9.32-31.72,19.1-5.3,6.54-9.2,14.42-15.96,19.42-6.79,5.03-15.5,6.43-23.64,8.72-15.53,4.36-24.49,15.71-18.78,27.88,6.38,13.61,21.49,14.78,31.21,17.41,11.07,3,24.76,9.85,40.23,6.82,12.77-2.5,23.05-15.79,34.14-22.6,13.28-8.15,23.82-9.91,32.44-21.85,12.22-16.93,5.09-40.26-11.34-49.25h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "padroes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M151.3,61.98c-.28-.2-.34-.59-.14-.87.48-.66.94-1.35,1.37-2.03.18-.29.57-.38.86-.2.29.18.38.57.2.86-.45.71-.92,1.41-1.42,2.1-.12.17-.31.26-.5.26-.13,0-.25-.04-.36-.12h0ZM154.76,56.44c-.31-.15-.43-.53-.28-.84.36-.73.7-1.48,1.01-2.23.13-.32.5-.47.81-.34s.47.5.34.81c-.32.77-.67,1.55-1.05,2.3-.11.22-.33.35-.56.35-.09,0-.19-.02-.28-.06h0ZM157.25,50.4c-.33-.1-.52-.45-.42-.77.23-.78.44-1.58.62-2.37.08-.34.41-.55.75-.47s.55.41.47.75c-.19.82-.4,1.64-.64,2.45-.08.27-.33.45-.6.45-.06,0-.12,0-.18-.03h0ZM158.67,44.03c-.34-.04-.59-.35-.54-.69.1-.81.17-1.63.21-2.44.02-.34.31-.61.65-.59.34.02.61.31.59.65-.05.84-.12,1.68-.22,2.52-.04.32-.31.55-.62.55-.03,0-.05,0-.07,0ZM158.34,36.92c-.04-.81-.11-1.63-.2-2.44-.04-.34.21-.65.55-.69.34-.03.65.21.69.55.09.84.16,1.68.2,2.52.02.34-.25.64-.59.65h-.03c-.33,0-.61-.26-.62-.59h0ZM157.52,30.54c-.05-.21-.09-.43-.14-.64-.13-.58-.28-1.17-.44-1.75-.09-.33.11-.67.44-.76.33-.09.67.11.76.44.16.59.31,1.2.45,1.8.05.22.1.44.14.66.07.34-.14.67-.48.74-.04,0-.08.01-.13.01-.29,0-.55-.2-.61-.5h0ZM155.71,24.36c-.29-.76-.6-1.53-.93-2.27-.14-.31,0-.68.31-.82.31-.14.68,0,.82.31.34.76.67,1.55.96,2.34.12.32-.04.68-.36.8-.07.03-.15.04-.22.04-.25,0-.49-.15-.58-.4ZM152.98,18.53c-.4-.71-.83-1.41-1.28-2.09-.19-.29-.11-.67.18-.86s.67-.11.86.18c.46.7.9,1.43,1.32,2.16.17.3.07.68-.23.85-.1.06-.2.08-.31.08-.22,0-.43-.11-.54-.31h0ZM149.36,13.22c-.51-.64-1.05-1.26-1.6-1.86-.23-.25-.22-.65.04-.88.25-.23.65-.22.88.04.56.62,1.12,1.26,1.65,1.92.22.27.17.66-.09.87-.11.09-.25.14-.39.14-.18,0-.36-.08-.48-.23ZM144.93,8.57c-.61-.54-1.24-1.07-1.88-1.57-.27-.21-.32-.6-.11-.87.21-.27.6-.32.87-.11.66.51,1.31,1.06,1.94,1.62.26.23.28.62.05.88-.12.14-.29.21-.47.21-.15,0-.3-.05-.41-.16h0ZM139.79,4.72c-.69-.43-1.4-.84-2.12-1.23-.31-.16-.42-.54-.25-.84.16-.3.54-.42.84-.25.74.39,1.48.82,2.19,1.26.29.18.38.56.2.86-.12.19-.32.29-.53.29-.11,0-.22-.03-.33-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M26.5,97.61c-.87-.17-1.68-.35-2.46-.53-.34-.08-.54-.42-.46-.75.08-.34.42-.54.75-.46.76.18,1.55.35,2.41.52.34.07.56.39.49.73-.06.3-.32.5-.61.5-.04,0-.08,0-.12-.01h0ZM20.09,95.98c-.82-.26-1.62-.55-2.38-.85-.32-.13-.47-.49-.35-.81s.49-.47.81-.35c.74.29,1.51.57,2.31.83.33.11.5.46.4.78-.08.26-.33.43-.59.43-.06,0-.13,0-.19-.03h0ZM13.98,93.38c-.75-.41-1.48-.86-2.18-1.32-.28-.19-.36-.58-.17-.87.19-.28.58-.36.87-.17.66.44,1.36.87,2.08,1.26.3.17.41.54.25.84-.11.21-.33.32-.55.32-.1,0-.2-.03-.3-.08h0ZM8.55,89.5c-.62-.58-1.22-1.19-1.78-1.82-.23-.26-.2-.65.05-.88.26-.23.65-.2.88.05.53.6,1.11,1.19,1.7,1.73.25.23.27.63.03.88-.12.13-.29.2-.46.2-.15,0-.3-.06-.42-.17h0ZM4.27,84.39c-.45-.7-.88-1.44-1.28-2.2-.16-.31-.04-.68.26-.84.31-.16.68-.04.84.26.38.73.79,1.43,1.22,2.1.19.29.1.67-.19.86-.11.07-.22.1-.34.1-.2,0-.41-.1-.53-.28h0ZM1.34,78.4c-.28-.81-.53-1.63-.72-2.45-.08-.34.13-.67.46-.75.34-.08.67.13.75.46.18.78.42,1.56.68,2.32.11.33-.06.68-.38.79-.07.03-.14.03-.2.03-.26,0-.5-.16-.59-.42h0ZM.03,71.84c-.02-.39-.03-.78-.03-1.17,0-.47.01-.93.04-1.39.02-.34.32-.61.66-.58.34.02.6.32.58.66-.03.43-.04.87-.04,1.31,0,.36,0,.74.03,1.11.02.34-.25.64-.59.65h-.03c-.33,0-.6-.26-.62-.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "objeto"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cor-5",
    className: "cls-6",
    d: "M92.09,103.17h-23.65l4.73-18.75h14.19l4.73,18.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sombra",
    className: "cls-5",
    d: "M89.01,90.95h-17.49l1.65-6.53h14.19l1.65,6.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-6",
    className: "cls-4",
    d: "M121.97,31.86v53.02c0,1.73-1.4,3.13-3.13,3.13H41.69c-1.73,0-3.13-1.4-3.13-3.13V31.86c0-1.73,1.4-3.13,3.13-3.13h77.16c1.73,0,3.13,1.4,3.13,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-7",
    className: "cls-7",
    d: "M121.97,38.78v-6.92c0-1.73-1.4-3.13-3.13-3.13H41.69c-1.73,0-3.13,1.4-3.13,3.13v6.92h83.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-8",
    className: "cls-11",
    d: "M38.56,77.5v7.38c0,1.73,1.4,3.13,3.13,3.13h77.16c1.73,0,3.13-1.4,3.13-3.13v-7.38H38.56Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "objeto-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_574",
    "data-name": "Caminho 574",
    className: "cls-9",
    d: "M46.5,34.81c-.58,0-1.04-.47-1.04-1.04h0v-.03c0-.58.47-1.04,1.04-1.04s1.04.47,1.04,1.04v.03c0,.58-.47,1.04-1.04,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_575",
    "data-name": "Caminho 575",
    className: "cls-9",
    d: "M50.53,34.81c-.58,0-1.04-.47-1.04-1.04h0v-.03c0-.58.47-1.04,1.04-1.04s1.04.47,1.04,1.04v.03c0,.58-.47,1.04-1.04,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_576",
    "data-name": "Caminho 576",
    className: "cls-9",
    d: "M54.56,34.81c-.58,0-1.04-.47-1.04-1.04h0v-.03c0-.58.47-1.04,1.04-1.04s1.04.47,1.04,1.04v.03c0,.58-.47,1.04-1.04,1.04h0Z"
  }))), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 70.55,
    y1: 69.91,
    x2: 83.01,
    y2: 69.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 88.3,
    y1: 69.91,
    x2: 99.97,
    y2: 69.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 61.25,
    y1: 69.91,
    x2: 64.96,
    y2: 69.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 71.95,
    y: 34.19,
    width: 15.84,
    height: 23.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.38,56.35c1.5,2.6-.38,5.85-3.38,5.85h-39.01c-3,0-4.88-3.26-3.38-5.85l19.5-33.82c1.5-2.6,5.26-2.6,6.76,0l19.5,33.82h0ZM80.49,49.35c-2.07,0-3.74,1.68-3.74,3.74s1.68,3.74,3.74,3.74,3.74-1.68,3.74-3.74-1.68-3.74-3.74-3.74ZM76.95,35.91l.6,11.06c.03.52.46.92.98.92h3.95c.52,0,.95-.4.98-.92l.6-11.06c.03-.56-.42-1.03-.98-1.03h-5.15c-.56,0-1.01.47-.98,1.03h0Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustracaoAtencao);
export default __webpack_public_path__ + "static/media/ilustracao-atencao.dd40655bfb38cf80d93a47d70b286e07.svg";
export { ForwardRef as ReactComponent };